<template>
  <v-container>
    <v-card elevation="0" class="ma-2 my-4">
      <page-title :title="'Hello ' + firstname + '!'"> </page-title>
      <vue-greetings class="vue__greetings" />
    </v-card>

    <!---------------- quick options-------------------->
    <!-- <h3 class="intro ">What Would you Like to do?</h3> -->
    <v-row justify="center" align="center" class="px-4 mt-1">
      <!--------------------quick options one of four-------------->
      <v-col cols="6">
        <router-link :to="{ name: 'search' }">
          <v-card class="px-1 py-1 lighten-4 green--text" elevation="0">
            <v-card-text class="
                        text-capitalize text-center
                        d-flex
                        justify-center
                        align-center
                        flex-column-reverse
                      ">

              past questions
              <v-img contain max-width="45px" src="@/assets/illustration/archive.png"></v-img>
            </v-card-text>
          </v-card>
        </router-link>
      </v-col>

      <!--------------------quick options two of four-------------->
      <v-col cols="6">
        <router-link :to="{ name: 'select-subject' }">
          <v-card class="px-3 py-3 lighten-4 green--text" elevation="0">
            <v-card-text class="
                text-capitalize
                d-flex
                text-center
                justify-center
                align-center
                flex-column-reverse
              ">

              mock test
              <v-img contain max-width="45px" src="@/assets/illustration/exam.png"></v-img>
            </v-card-text>
          </v-card>
        </router-link>
      </v-col>

      <!--------------------quick options three of four-------------->
      <v-col cols="6">

        <router-link :to="{ name: 'shelf' }">
          <v-card class="px-3 py-3 lighten-4 green--text" elevation="0">
            <v-card-text class="
                      text-capitalize
                      d-flex
                      justify-center
                      align-center
                      flex-column-reverse
                    ">
              Maths Solver

              <v-img contain max-width="45px" src="@/assets/illustration/maths-solver.png"></v-img>
            </v-card-text>
          </v-card>
        </router-link>

      </v-col>

      <!--------------------quick options four of four-------------->
      <v-col cols="6">
        <router-link :to="{ name: 'forum' }">
          <v-card class="px-3 py-3 lighten-4 green--text" elevation="0">
            <v-card-text class="
                text-capitalize text-center
                d-flex
                justify-center
                align-center
                flex-column-reverse
              ">
              Join live chat

              <v-img contain max-width="45px" src="@/assets/illustration/chat.png"></v-img>
            </v-card-text>
          </v-card>
        </router-link>
      </v-col>
    </v-row>
    <v-card elevation="0"> </v-card>
  </v-container>
</template>

<script>
// import store to ba able to compute user first name
import store from "@/store";

import { mapGetters } from "vuex";
import VueGreetings from "vue-greetings";
import PageTitle from "../../components/PageTitle.vue";
export default {
  components: {
    VueGreetings,
    PageTitle,
  },

  data() {
    return {
      query: "",
      response: {},
    };
  },

  methods: {},

  computed: {
    ...mapGetters({
      authenticated: "auth/authenticated",
      user: "auth/user",
    }),

    //get user firstname from central store
    firstname: () => store.getters["auth/user"].firstname,
  },
};
</script>

<style scoped>
.vue__greetings {
  font-size: 80%;
  color: grey;
}

a,
a:hover,
a:link,
a:visited,
a:active {
  text-decoration: none;
}

h3.intro {
  color: var(--grey);
  text-align: center;
  font-weight: 300;
  line-height: 20px;
  margin-top: 2.5rem;
  margin-bottom: 0.25rem;
}
</style>